<template>
	<v-container class="px-12 p-relative" fluid>
		<!--    Filtros -->
		<v-row class="mb-0 mx-0" style="min-width: 720px">
			<v-container class="d-flex justify-start pa-0" fluid>
				<v-flex class="pt-0 mr-1">
					<span class="filtros-label ">Produtor</span>
					<v-text-field outlined dense v-model="nmProdutor" :loading="loading" clearable
					              @click:clear="loadListaCreches()" color="#2BC1B6" @keydown.enter="pesquisar()" />
				</v-flex>
				<v-flex class="pt-0 mr-1">
					<span class="filtros-label ">Pavilhão</span>
					<v-text-field outlined dense v-model="nrPavilhao" :loading="loading" clearable
					              @click:clear="loadListaCreches()"
					              color="#2BC1B6" v-mask="'########'" @keydown.enter="pesquisar()" />
				</v-flex>
				<v-flex class="pt-0 mr-1">
					<span class="filtros-label ">UEP</span>
					<v-text-field outlined dense v-model="nrUnidadeExploracao" :loading="loading" clearable
					              @click:clear="loadListaCreches()"
					              color="#2BC1B6" v-mask="'########'" @keydown.enter="pesquisar()" />
				</v-flex>
				<v-flex class="pt-0 mr-1">
					<span class="filtros-label text-no-wrap">Lote de controle</span>
					<v-text-field outlined dense v-model="nrLoteControle" :loading="loading" clearable
					              @click:clear="loadListaCreches()"
					              color="#2BC1B6" @keydown.enter="pesquisar()" />
				</v-flex>
				<v-flex class="pt-0 mr-1">
					<span class="filtros-label text-no-wrap">Mínimo de dias alojamento</span>
					<v-text-field outlined dense v-model="nrDiasLote" :loading="loading" clearable
					              @click:clear="loadListaCreches()"
					              color="#2BC1B6" v-mask="'########'" @keydown.enter="pesquisar()" />
				</v-flex>
				<v-flex shrink class="pt-0 d-flex justify-center align-center">
					<v-btn elevation="0" color="#2BC1B6" height="40" class="btn-buscar" dark
					       @click="pesquisar()">
						Buscar
					</v-btn>
				</v-flex>
				<v-flex shrink class="pt-0 d-flex justify-center align-center">
					<novo-crechario-dialog :addCrecharioDialog.sync="addCrecharioDialog" @loadCreches="loadListaCreches()">
						<template v-slot:activator="{ on }">
							<v-btn elevation="0" color="#2BC1B6" height="40" class="btn-buscar align-self-center ml-4" dark
							       @click="addCrecharioDialog = true">
								Adicionar crechário
							</v-btn>
						</template>
					</novo-crechario-dialog>
				</v-flex>
			</v-container>
		</v-row>
		<!--    Cards   -->
		<v-row class="mb-8" v-if="loading">
			<v-col v-for="n in 12" :key="n" cols="12" md="4" lg="3" xl="2">
				<v-sheet min-height="270">
					<v-skeleton-loader type="image" />
				</v-sheet>
			</v-col>
		</v-row>
		<v-row class="mb-8" v-if="!loading">
			<v-virtual-scroll
					bench="3"
					:items="chunkedLotes"
					item-height="420"
					min-height="400"
					max-height="680"
					min-width="720"
					width="100%"
			>
				<template v-slot="{ item }">
					<v-row class="ma-0">
						<v-col v-for="(card) in item" :key="card['idPlanejamentoAlojamentoCreches']" cols="12" md="4" lg="3" xl="2">
							<creches-card :item="card" @selecionarLote="selecionarLotes(card.id, $event)"
							              @loteDeletado="loadListaCreches()" @preencherObservacao="preencherObservacao(card.id, $event)" />
						</v-col>
					</v-row>
				</template>
			</v-virtual-scroll>
		</v-row>
	</v-container>
</template>

<script>
import {mask} from "vue-the-mask";
import CrechesCard from "./CrechesCard";
import NovoCrecharioDialog from "./NovoCrecharioDialog";
import moment from "moment";

export default {
	name: "Creches",
	directives: {mask},
	components: {CrechesCard, NovoCrecharioDialog},
	data: () => ({
		nmProdutor: '',
		nrUnidadeExploracao: null,
		nrPavilhao: '',
		nrLoteControle: '',
		nrDiasLote: null,
		listaCreches: [],
		idsSelecionadas: [],
		loading: false,
		queryFiltros: {
			nmProdutor: '',
			nrUnidadeExploracao: null,
			nrPavilhao: '',
			nrLoteControle: '',
			nrDiasLote: null,
		},
		editing: false,
		addCrecharioDialog: false,
	}),
	computed: {
		chunkedLotes() {
			let array = this.listaCreches
			const queryFiltros = this.queryFiltros

			if (queryFiltros.nmProdutor)
				array = array.filter(lote => lote.nmProdutor.toLowerCase().startsWith(queryFiltros.nmProdutor.toLowerCase()))

			if (queryFiltros.nrUnidadeExploracao > 0)
				array = array.filter(lote => parseInt(lote.nrUnidadeExploracao) === parseInt(queryFiltros.nrUnidadeExploracao))

			if (queryFiltros.nrPavilhao > 0)
				array = array.filter(lote => parseInt(lote.nrPavilhao) === parseInt(queryFiltros.nrPavilhao))

			if (queryFiltros.nrLoteControle)
				array = array.filter(lote =>
						lote.nrLoteControle ?
								lote.nrLoteControle.toLowerCase().startsWith(queryFiltros.nrLoteControle.toLowerCase()) :
								false)

			if (queryFiltros.nrDiasLote > 0)
				array = array.filter(lote => parseInt(lote.nrDiasLote) >= parseInt(queryFiltros.nrDiasLote))

			let totalChunks = [];
			let chunkLength = 1;

			switch (this.$vuetify.breakpoint.name) {
				case 'md':
					chunkLength = 3;
					break;
				case 'lg':
					chunkLength = 4;
					break;
				case 'xl':
					chunkLength = 6;
					break;
			}

			if (chunkLength <= 0) {
				return array;
			}

			// Loop through the data and divide it into chunks
			for (let i = 0; i < array.length; i += chunkLength) {
				totalChunks.push(array.slice(i, i + chunkLength));
			}

			// Return the chunks of data
			return totalChunks;
		}
	},
	methods: {
		selecionarLotes(id, valor) {
			this.listaCreches[id].blSelecionado = valor
		},
		preencherObservacao(id, valor) {
			this.listaCreches[id].dsObservacao = valor
		},
		alterarCreches() {
			const crechesSelecionadas = this.listaCreches.filter((lote) => lote.blSelecionado === true)
			const idsSelecionados = crechesSelecionadas.map(lote => lote.id)

			let requests = [];
			
			//Incluir
			const idsParaIncluir = idsSelecionados.filter(id => !this.idsSelecionadas.includes(id))
			if (idsParaIncluir && idsParaIncluir.length > 0) {
				requests.push(this.$axios.post('/planejamento-alojamento-disponibilidade/selecionar-creches/',
						idsParaIncluir.map(id => this.listaCreches[id]))
						.then(res => {
							if (!res.data) return
							if (!res.data[0].data) return

							if (res.data[0].data.length !== idsParaIncluir.length) {
								this.$store.commit("setSnack", {type: "error", msg: 'Houve um erro ao Selecionar os Lotes'})
								this.limparFiltros()
							}
						})
						.catch(error => {
							this.$store.commit("setSnack", {type: "error", msg: error});
						})
				)
			}

			//Alterar
			const idsParaAlterar = idsSelecionados.filter(id => this.idsSelecionadas.includes(id))
			if (idsParaAlterar && idsParaAlterar.length > 0) {
				let listaUpdate = idsParaAlterar.map(id => this.listaCreches[id])
				let context = this
				let counterUpdated = 0
				listaUpdate.forEach(function (creche) {
					requests.push(context.$axios.put('/planejamento-alojamento-disponibilidade/' + 
						creche.cdPlanejamentoAlojamentoDisponibilidade, creche)
						.then(res => {
							if (!res.data) return
							if (!res.data[0].data) return
							counterUpdated = counterUpdated + 1
						})
						.catch(error => {
							context.$store.commit("setSnack", {type: "error", msg: error});
						})
					)
				})
				if (counterUpdated !== idsParaAlterar.length) {
					context.$store.commit("setSnack", {type: "error", msg: 'Houve um erro ao Atualizar as Creches'})
				}
			}

			//Excluir
			const idsParaExcluir = this.idsSelecionadas.filter(id => !idsSelecionados.includes(id))
			const idPlanejamentoAlojamentoDisponibilidadeParaExcluir = idsParaExcluir.map(id =>
					this.listaCreches[id]['cdPlanejamentoAlojamentoDisponibilidade'])

			if (idPlanejamentoAlojamentoDisponibilidadeParaExcluir && idPlanejamentoAlojamentoDisponibilidadeParaExcluir.length > 0) {
				requests.push(this.$axios.delete('/planejamento-alojamento-disponibilidade/remover-creches-selecionadas/?pk=' +
						idPlanejamentoAlojamentoDisponibilidadeParaExcluir.join(','))
						.then(res => {
							if (!res.data) return
							if (!res.data[0].data) return

							const crechesExcluidas = res.data[0].data

							if (crechesExcluidas.length !== idPlanejamentoAlojamentoDisponibilidadeParaExcluir.length) {
								this.$store.commit("setSnack", {type: "error", msg: 'Houve um erro ao desselecionar os lotes'})
							}
						})
						.catch(error => {
							this.$store.commit("setSnack", {type: "error", msg: error});
						})
				)
			}

			Promise.all(requests).then(() => {
				this.$store.commit("setSnack", {type: "success", msg: 'Creches Selecionadas!'})
				if (this.planejamentoAlojamento.cdStatusPlanejamentoAlojamento <= 2) this.$emit('proximaEtapa', 3)
				{
					this.loadListaCreches()
					this.btnSelecionarCreches()
				}
			})
		},
		loadListaCreches() {
			this.loading = true
			this.limparFiltros()

			let query = {
				cdPlanejamentoAlojamento: this.$route.params.id
			}

			//Pesquisa sendo feita pelo front até então
			// if (this.nmEstabelecimento && this.nmEstabelecimento !== '') query['nmEstabelecimento'] = this.nmEstabelecimento
			// if (this.nmProdutor && this.nmProdutor !== '') query['nmProdutor'] = this.nmProdutor
			// if (this.nrUnidadeExploracao > 0) query['nrUnidadeExploracao'] = this.nrUnidadeExploracao

			this.$axios.get('planejamento-alojamento/creches-disponiveis/', {
				params: query
			})
					.then(res => {
						if (!res.data) return
						if (!res.data[0].data) return

						this.listaCreches = res.data[0].data.map((lote, index) => _.extend(lote, {
							id: index,
						}))

						this.idsSelecionadas = this.listaCreches.filter((creche) => creche.blSelecionado === true)
								.map(creche => creche.id)
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error});
					})
					.finally(() => {
						this.loading = false;
					})
		},
		limparFiltros() {
			this.queryFiltros = {
				nmProdutor: '',
				nrUnidadeExploracao: null,
				nrPavilhao: '',
				nrLoteControle: '',
				nrDiasLote: null,
			}
			this.idsSelecionadas = []
		},
		pesquisar() {
			this.queryFiltros = {
				nmProdutor: this.nmProdutor,
				nrPavilhao: this.nrPavilhao,
				nrUnidadeExploracao: this.nrUnidadeExploracao,
				nrLoteControle: this.nrLoteControle,
				nrDiasLote: this.nrDiasLote
			}
		},
		esconderBtn() {
			this.$emit('update:btnConfirmar', {
				disable: false,
				texto: 'Confirmar',
				acao: false,
				acaoType: ''
			})
		},
		btnSelecionarCreches() {
			this.$emit('update:btnConfirmar', {
				disable: false,
				texto: 'Confirmar',
				acao: false,
				acaoType: 'selecionarCreches'
			})
		},
	},
	mounted() {
		this.btnSelecionarCreches()
		this.loadListaCreches()
		this.limparFiltros()
	},
	watch: {
		'btnConfirmar.acao'(acao) {
			if (acao && this.btnConfirmar.acaoType === 'selecionarCreches') {
				this.alterarCreches()
			}
		}
	},
	props: {
		btnConfirmar: {
			disable: true,
			texto: null,
			acao: false,
			acaoType: ''
		},
		planejamentoAlojamento: {},
	},
}
</script>

<style scoped>
.filtros-label {
    text-align: left;
    font: normal normal normal 10px/13px Roboto;
    letter-spacing: 0;
    color: #7B9596;
    opacity: 1;
}

.v-skeleton-loader:first-child :first-child {
    height: 270px;
}

.btn-buscar {
    margin-bottom: 2px;
    height: 40px;
}
</style>